export const permissions: any = {
  REVENUE_ADMINISTRATOR: 'Revenue Administrator',
  TIRE_ORDERING: 'Tire Ordering',
  CONTRACT: 'Contract',
  TERMS: 'Terms',
  QUOTE: 'Quote',
  RECORD_KEEPER: 'Record Keeper',
};